import AccountantsSheet from "../../Component/Admin/AccountantsSheet";
import Accounts from "../../Component/Admin/Accounts";
import CoursesManagementPage from "../../Component/Admin/CoursesManagement/CoursesManagementPage";
import CurrencyPrices from "../../Component/Admin/CurrencyPrices";
import Devices from "../../Component/Admin/Devices";
import HRPage from "../../Component/Admin/HRPage";
import PerformanceReports from "../../Component/Admin/PerformanceReports";
import Reports from "../../Component/Admin/Reports";
import SalarysSettings from "../../Component/Admin/SalarysSettings";
import AddClient from "../../Component/Management/AddClient";
import Clients from "../../Component/Management/Clients";
import ConfirmSalaries from "../../Component/Management/ConfirmSalaries";
import Marketers from "../../Component/Management/Marketers";
import RecieveSalaries from "../../Component/Management/RecieveSalaries";
import PrintedCertificates from "../../Component/Printing/PrintedCertificates";
import PrintingList from "../../Component/Printing/PrintingList";
import { Globals } from "../Globals/GlobalObs";
import { InterActive } from "../utilities/ViewModelStructure";

export class SideBarVM extends InterActive{
    private collapsed:boolean = false
    private selectedPage:string = ''
    private sideBarPages:{page:string , content:React.ComponentType}[] = []

    public get Collapsed():boolean { return this.collapsed }
    public get SelectedPage():string { return this.selectedPage }
    public get SideBarPages():{page:string , content:React.ComponentType}[] { return this.sideBarPages }

    public set Collapsed(value:boolean) { this.collapsed = value; this.update() }
    public set SelectedPage(value:string){ this.selectedPage = value; this.update() }

    public getSideTabs():{page:string , content:React.ComponentType}[]{
        if(Globals.auth.Auth){
            if(Globals.auth.User){
                const pagesList:{page:string , content:React.ComponentType}[] = []
                if(Globals.auth.User.permissions.some(a=>(a.id=='19' || a.id =='20' || a.id=='8'|| a.id=='1')))pagesList.push({page:'الموارد البشرية' , content:HRPage })

                if(Globals.auth.User.permissions.some(a=>(a.id=='10' || a.id =='11' || a.id=='12' || a.id=='13' || a.id=='25')))pagesList.push({page:'ادارة الدورات' , content:CoursesManagementPage })
                if(Globals.auth.User.permissions.some(a=>a.id=='14'))pagesList.push({page:'اعتماد المرتبات' , content:ConfirmSalaries })
                if(Globals.auth.User.permissions.some(a=>a.id=='16'))pagesList.push({page:'سداد المرتبات' , content:RecieveSalaries })
                if(Globals.auth.User.permissions.some(a=>a.id=='30'))pagesList.push({page:'اعدادات المرتبات' , content:SalarysSettings })

                if(Globals.auth.User.permissions.some(a=>a.id=='18')){
                    pagesList.push({page:'الطباعة' , content:PrintingList })
                    pagesList.push({page:'المطبوعات' , content:PrintedCertificates })
                }
                if(Globals.auth.User.permissions.some(a=>a.id=='22'))pagesList.push({page:'العملات' , content:CurrencyPrices })
                if(Globals.auth.User.permissions.some(a=>a.id=='31'))pagesList.push({page:'حسابات التحويل' , content:Accounts })
                
                if(Globals.auth.User.permissions.some(a=>(a.id=='32'||a.id=='26'||a.id=='33'||a.id=='34'||a.id=='35')))pagesList.push({page:'التقارير' , content:PerformanceReports })
                    
                if(Globals.auth.User.permissions.some(a=>a.id=='24'))pagesList.push({page:'الاجهزة' , content:Devices })
                if(Globals.auth.User.permissions.some(a=>a.id=='28'))pagesList.push({page:'شيت الصادر و الوارد' , content:AccountantsSheet })
                if(Globals.auth.User.permissions.some(a=>a.id=='29'))pagesList.push({page:'سجل الانشطة' , content:Reports })
                    
                return this.sideBarPages = pagesList;
            }
        } return [ ]
    }
    
}